import React from "react";
import Navbar from "../Components/Navbar";
import HelpMessage from "../Components/HelpMessage";

const appfieldsData = [
  { heading: "Person/Org Nr", value: "5512273631" },
  { heading: "Titel 1", value: "Ägare" },
  { heading: "Kontakt 1", value: "Anders Johnsson" },
  { heading: "Kontakt 1 Mobil", value: "0708-839312" },
  { heading: "Titel 2", value: "Ägare" },
  { heading: "Kontakt 2", value: "Lena Johnsson" },
  { heading: "Släpvagnstillägg", value: "J" },
  { heading: "Mj syst Robot", value: "J" },
  { heading: "Mj syst Conv.", value: "-" },
  { heading: "Kontakt 4 Mobil", value: "-" },
  { heading: "Hämtadress/Pickup	", value: "Rörum Aspekulle" },
  { heading: "Post nr	", value: "272 95" },
  { heading: "Post ort	", value: "Simrishamn" },
  { heading: "KO=K/PG=P/BG=G	", value: "-" },
  { heading: "Oberoende hämt	", value: "J" },
];

const AppField = () => {
  const supplierName = (localStorage.getItem("supplierName") || "").trim();
  const supplierCode = (localStorage.getItem("currentUser") || "").trim();

  const subtitle = supplierName || supplierCode
    ? `Key account fields for supplier ${supplierName || supplierCode}.`
    : "Key account fields for the selected supplier.";

  return (
    <div className="customer-layout">
      <Navbar />
      <main className="customer-main">
        <section className="card appfield-card table-card">
          <header className="card-header card-header--stacked">
            <h1 className="page-hero__title">Account details</h1>
            <p className="page-subtitle">{subtitle}</p>
          </header>

          <div className="appfield-table-wrapper">
            <table className="uds-table appfield-table">
              <thead>
                <tr>
                  <th scope="col">Heading</th>
                  <th scope="col">Value</th>
                </tr>
              </thead>
              <tbody>
                {appfieldsData.map((field) => (
                  <tr key={field.heading}>
                    <td>{field.heading}</td>
                    <td>{field.value}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <HelpMessage />
        </section>
      </main>
    </div>
  );
};

export default AppField;
